// extracted by mini-css-extract-plugin
export var avatar = "styles-module--avatar--e5+kN";
export var xs = "styles-module--xs--tgdps";
export var sm = "styles-module--sm--DX9T7";
export var md = "styles-module--md--O3KOE";
export var lg = "styles-module--lg--yCAE-";
export var xl = "styles-module--xl--EzboQ";
export var xxl = "styles-module--xxl--V7iQV";
export var xxxl = "styles-module--xxxl--M6Kr3";